export const TicketLaneTypes =  Object.freeze({ 
    VERTRIEB: "VERTRIEB",
    STOFFSTROM: "STOFFSTROM",
    LABOR: "LABOR"
})